import React from 'react';
import { NavLink } from 'react-router-dom';
import { HeartIcon, HomeIcon, SearchIcon } from 'lucide-react';
const items = [{
  to: '/',
  label: 'Home',
  Icon: HomeIcon
}, {
  to: '/search',
  label: 'Search',
  Icon: SearchIcon
}, {
  to: '/favorites',
  label: 'Favorites',
  Icon: HeartIcon
}];
export function BottomNav() {
  return <nav aria-label="Primary" className="fixed bottom-0 left-1/2 z-30 w-full max-w-app -translate-x-1/2 px-4 pb-4 pt-2" data-id="element-28" data-mp="2xqpsag0nalv2">
      <div className="glass flex items-stretch justify-between gap-1 rounded-3xl p-1.5" style={{
      boxShadow: '0 -8px 40px -18px rgba(0,0,0,0.9), 0 18px 40px -28px rgba(0,0,0,0.9)'
    }} data-id="element-29" data-mp="2oqkn8cixbzk2">
        {items.map(({
        to,
        label,
        Icon
      }) => <NavLink key={to} to={to} end={to === '/'} className="group relative flex flex-1 flex-col items-center gap-1 rounded-2xl px-3 py-2.5 text-[11px] font-medium tracking-wide text-lav-dim transition-colors duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70 aria-[current=page]:text-white" data-id="element-30" data-mp="2ety1zmmor6hi">
            {({
          isActive
        }) => <>
                {isActive && <span aria-hidden="true" className="absolute inset-0 rounded-2xl" style={{
            background: 'linear-gradient(180deg, rgba(139,92,246,0.28) 0%, rgba(109,40,217,0.14) 100%)',
            boxShadow: '0 0 22px -6px rgba(139,92,246,0.7), inset 0 0 0 1px rgba(167,139,250,0.35)'
          }} data-id="element-31" data-mp="3v6j8d3m8mruv" />}
                <Icon className="relative h-[18px] w-[18px] transition-transform duration-200 ease-smooth group-active:scale-90" strokeWidth={1.9} fill={isActive && label === 'Favorites' ? 'currentColor' : 'none'} data-id="element-32" data-mp="mxj1ido05uc4" />
                <span className="relative" data-id="element-33" data-mp="1pa28sinpv5vw">{label}</span>
              </>}
          </NavLink>)}
      </div>
    </nav>;
}